// frontend/src/LoginPage.js
import React, { useEffect, useRef, useState } from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import vortiqLogo from '../assets/logofull.png';
import './LoginPage.css';

const LoginPage = () => {
    const { handleLogin } = useAuthContext();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const mountedRef = useRef(true);

    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        let succeeded = false;
        try {
            await handleLogin(email, password);
            succeeded = true;
            // O redirecionamento será feito automaticamente pelo PublicRoute
            // quando isAuth se tornar true
        } catch (err) {
            if (mountedRef.current) {
                setError(err.message || 'Falha na autenticação. Verifique suas credenciais.');
            }
        } finally {
            if (!succeeded && mountedRef.current) {
                setIsLoading(false);
            }
        }
    };

    return (
        <div className="login-page-background">
            <div className="login-container-blur">
                <div className="login-branding-panel">
                    <img
                        src={vortiqLogo}
                        alt="VORTIQA"
                        className="login-logo-main"
                    />
                </div>
                <div className="login-form-panel">
                    <h2>Entrar</h2>
                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="form-group">
                            <FaUser className="input-icon" />
                            <input
                                type="email"
                                id="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                autoComplete="email"
                            />
                        </div>
                        <div className="form-group">
                            <FaLock className="input-icon" />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                placeholder="Senha"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoComplete="current-password"
                            />
                            <div className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </div>
                        </div>
                        {error && (
                            <div className="error-container">
                                <p className="error-message">{error}</p>
                            </div>
                        )}
                        <button type="submit" className="login-button-green" disabled={isLoading}>
                            {isLoading ? 'Entrando...' : 'Entrar'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
